import React from 'react';

const Logo = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        id='Capa_1'
        enableBackground='new 0 0 512 512'
        viewBox='0 0 512 512'
        height='40px'
        width='40px'
      >
        <g>
          <circle cx='256' cy='256' fill='#ff6b6b' r='256' />
          <path
            d='m512 256h-512c0 141.385 114.615 256 256 256s256-114.615 256-256z'
            fill='#ff1f3d'
          />
          <g>
            <g>
              <path
                d='m185.999 401c-2.333 0-4.673-.543-6.827-1.645-5.016-2.564-8.172-7.722-8.172-13.355v-260c0-5.633 3.156-10.791 8.171-13.355s11.044-2.103 15.611 1.195l180 130c3.905 2.82 6.218 7.344 6.218 12.16s-2.313 9.34-6.218 12.16l-180 130c-2.605 1.882-5.686 2.84-8.783 2.84z'
                fill='#f9f9f9'
              />
            </g>
          </g>
          <g>
            <path
              d='m171 256v130c0 5.633 3.156 10.791 8.171 13.355 2.154 1.102 4.495 1.645 6.827 1.645 3.097 0 6.179-.958 8.784-2.84l180-130c3.904-2.82 6.218-7.344 6.218-12.16z'
              fill='#e2dff4'
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default Logo;
